import { Component } from '@angular/core';

@Component({
    selector: 'om-search-tips',
    templateUrl: './search-tips.component.html',
    styleUrls: ['./search-tips.component.css']
})
export class SearchTipsComponent {

    visible: boolean;

    title = 'Search Shortcut Hints and Formats';
    tips: any[] = [
        {
            label: 'mpms:',
            text: '###'
        },
        {
            label: 'brkey:',
            text: '###'
        },
        {
            label: 'SAP:',
            text: '###'
        },
        {
            label: 'rms:',
            text: '##|####|#### ((cty|route|segment))'
        },
        {
            label: 'mile:',
            text: '###'
        },
        {
            label: 'exit:',
            text: '### or XXX'
        },
        {
            label: 'zip:',
            text: '###'
        },
        {
            label: 'cty:',
            text: '## or XXX'
        },
        {
            label: 'dist:',
            text: '##'
        },
        {
            label: 'int:',
            text: 'XXX and XXX  ((example: queen st and main st))'
        }
    ];

    comments: string[] = [
        'You can also just type in a name or number and search all types.',
        'Other features to search: Muni, Leg. Districts, School Districts, Planning Partner.',
        'Lat/Long example: 40.265, -76.884'
    ];
}
